<script setup lang="ts">
const iframeSrc = 'https://laam-help-center.super.site/';
</script>

<template>
	<div class="w-full h-full flex flex-col">
		<MobileHeader
			v-if="isMobileView()"
			:static="true"
			:selected-tab-val="'account'"
		>
			<template #title> Help Center</template>
			<template #actions><div></div></template>
		</MobileHeader>
		<div class="iframe-container !mt-[6rem]">
			<iframe :src="iframeSrc" width="100%" height="100%"> </iframe>
			<!-- <div v-if="isMobileView()" class="closeIcon cursor-pointer">
		<PhX size="24" color="#ffffff" />
	</div> -->
		</div>
	</div>
</template>

<style scoped>
.iframe-container {
	width: 100%;
	height: 100vh;
	overflow: hidden;
}

@media screen and (max-width: 500px) {
	.iframe-container {
		margin-top: 0px !important;
		position: relative;
	}
	.closeIcon {
		position: absolute;
		right: 22px;
		top: 24px;
	}
}
</style>
